var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5C10.2099 5 8.76908 6.44081 8.76908 8.23077V10.3846C7.58489 10.3846 6.61523 11.3543 6.61523 12.5385V16.8462C6.61523 18.0303 7.58489 19 8.76908 19H15.2306C16.4148 19 17.3845 18.0303 17.3845 16.8462V12.5385C17.3845 11.3543 16.4148 10.3846 15.2306 10.3846H9.846V8.23077C9.846 7.00451 10.7736 6.07692 11.9999 6.07692C13.2261 6.07692 14.1537 7.00451 14.1537 8.23077V8.76923H15.2306V8.23077C15.2306 6.44081 13.7898 5 11.9999 5ZM11.9999 13.0769C12.593 13.0769 13.0768 13.5607 13.0768 14.1538C13.0768 14.5303 12.8622 14.9005 12.5383 15.0625V16.3077C12.5383 16.6316 12.3238 16.8462 11.9999 16.8462C11.6759 16.8462 11.4614 16.6316 11.4614 16.3077V15.0625C11.1375 14.9005 10.9229 14.5303 10.9229 14.1538C10.9229 13.5607 11.4067 13.0769 11.9999 13.0769Z",
    fill: "#E2E2E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.52b1e080165ecf2fb992e1d1317ade93.svg";
export { ForwardRef as ReactComponent };